import React from 'react';

interface BarChartProps {
  data: Array<{ label: string; value: number; color?: string }>;
  maxHeight?: number;
}

export const BarChart: React.FC<BarChartProps> = ({
  data,
  maxHeight = 150
}) => {
  const maxValue = Math.max(...data.map(d => d.value), 1);
  
  return (
    <div className="flex items-end justify-between h-full space-x-2">
      {data.map((item, index) => {
        const height = maxValue > 0 ? (item.value / maxValue) * maxHeight : 0;
        return (
          <div key={index} className="flex flex-col items-center flex-1">
            <div className="text-xs text-gray-600 mb-1 font-medium">{item.value}</div>
            <div
              className="w-full rounded-t-md transition-all duration-500 ease-out min-w-[24px]"
              style={{
                height: `${height}px`,
                backgroundColor: item.color || '#8b5cf6'
              }}
            />
            <div className="text-xs text-gray-500 mt-2 text-center">{item.label}</div>
          </div>
        );
      })}
    </div>
  );
};

export default BarChart;
